import { render, staticRenderFns } from "./BodyOnduleur.vue?vue&type=template&id=8f50969e&scoped=true"
import script from "./BodyOnduleur.vue?vue&type=script&lang=js"
export * from "./BodyOnduleur.vue?vue&type=script&lang=js"
import style0 from "./BodyOnduleur.vue?vue&type=style&index=0&id=8f50969e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f50969e",
  null
  
)

export default component.exports